import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useUser } from "../features/auth/UserContext";
import { fetchWithoutToken } from "../features/api/api";

const Callback = () => {
  const { user, setUser } = useUser();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (user) {
      navigate("/dashboard", { replace: true });
      return;
    }

    const fetchJWT = async () => {
      const codeParam = searchParams.get("code");
      if (!codeParam) {
        navigate("/login", { replace: true });
        return;
      }

      try {
        const response = await fetchWithoutToken(
          `/oauth/callback?code=${codeParam}`
        );

        if (!response?.token) {
          throw new Error(response?.message || "Failed to authenticate");
        }

        localStorage.setItem("post-plant-token", response.token);
        setUser(response.user);
        navigate("/dashboard", { replace: true });
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Authentication failed. Please try again.";
        sessionStorage.setItem("authError", message);
        navigate("/login", { replace: true });
      }
    };

    fetchJWT();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default Callback;
